import { motion } from "framer-motion";
import { Video, Layers } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-24 bg-foreground text-background relative overflow-hidden">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-primary/5 blur-3xl rounded-full transform translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-secondary/5 blur-3xl rounded-full transform -translate-x-1/2" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-6">
              We Bridge the Gap Between <br />
              <span className="text-primary">Vision and Reality</span>
            </h2>
            
            <div className="flex gap-4 mb-8">
              <div className="bg-background/10 p-4 rounded-lg backdrop-blur-sm border border-white/10 flex-1">
                <Video className="w-6 h-6 text-primary mb-2" />
                <h3 className="font-bold mb-1 text-sm">Creative Production</h3>
                <p className="text-xs text-muted-foreground">High-end reel editing & multimedia content.</p>
              </div>
              <div className="bg-background/10 p-4 rounded-lg backdrop-blur-sm border border-white/10 flex-1">
                <Layers className="w-6 h-6 text-secondary mb-2" />
                <h3 className="font-bold mb-1 text-sm">Technical Excellence</h3>
                <p className="text-xs text-muted-foreground">Robust web frameworks & scalable code.</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Horizon Global is a premier digital solutions provider committed to elevating businesses through innovative technology and creative strategy. 
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              We don't just build websites; we create digital ecosystems that foster growth, engagement, and long-term success. From startups to established enterprises, we provide the framework support and social strategies needed to thrive in a connected world.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Our creative team specializes in multimedia production, including professional **reel editing** and video content optimization, ensuring your brand captures attention in an increasingly visual digital landscape.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mt-8">
              <div>
                <h4 className="text-3xl font-bold text-primary mb-2">100+</h4>
                <p className="text-sm text-muted-foreground">Projects Completed</p>
              </div>
              <div>
                <h4 className="text-3xl font-bold text-secondary mb-2">98%</h4>
                <p className="text-sm text-muted-foreground">Client Satisfaction</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
